import React from 'react';

/** Viewfinder corner brackets — shown on hover/focus of a `.has-corners` parent. */
const Corners = () => (
  <span className="corners" aria-hidden="true">
    <i /><i /><i /><i />
  </span>
);

export default Corners;
